<template>
  <div id="app">
    <!-- 搜索 -->
    <!-- <div class="seach">
            <el-input v-model="body.project_word" style="width: 391px; margin-right: 10px;" placeholder="请输入要查找的关键字" @keyup.enter.native="search"></el-input>
            <el-button type="primary" style="width: 140px;" @click.native.prevent="search">搜索</el-button>
        </div> -->
    <!-- 筛选 -->
    <div class="filter">
      <div class="filter-top">
        <!-- <div class="filter-top-left">
                    <div class="select">
                        <p>职能分类</p>
                        <el-cascader v-model="props.positions" :options="prem.positions" :props="{expandTrigger: 'hover', value: 'id', label: 'name' }" @change="posChange"></el-cascader>
                    </div>
                    <div class="select">
                        <p>期望地点</p>
                        <el-cascader v-model="props.city" :options="prem.citys" :props="{expandTrigger: 'hover', value: 'code', label: 'name', children: 'cities' }" @change="cityChange"></el-cascader>
                    </div>
                    <div class="select">
                        <p>工作年限</p>
                        <el-select v-model="props.years" placeholder="请选择">
                            <el-option v-for="item in prem.years" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                    <div class="select">
                        <p>求职状态</p>
                        <el-select v-model="props.job" placeholder="请选择">
                            <el-option v-for="item in prem.job_status" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                    <div class="select">
                        <p>学历</p>
                        <el-select v-model="body.educ_list" placeholder="请选择">
                            <el-option v-for="item in prem.educations" :key="item.id" :label="item.name == '不限'?item.name:`${item.name}及以上`" :value="item.id"></el-option>
                        </el-select>
                    </div>
                    <div class="select">
                        <p>期望薪资</p>
                        <div class="select-input">
                            <input v-model="body.wish_salary[0]" />
                            <span> ~ </span>
                            <input v-model="body.wish_salary[1]" />
                        </div>
                        <span class="select-unit">万/年</span>
                        <span class="select-prompt" v-if="salaryShow">*您的输入不正确，请重新输入</span>
                    </div>
                </div> -->
        <div class="filter-top-left">
          <div class="select">
            <p>学历要求</p>
            <el-select v-model="body.educ_list" placeholder="请选择">
              <el-option
                v-for="item in prem.educations"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="select">
            <p>工作经验</p>
            <el-select v-model="props.years" placeholder="请选择">
              <el-option
                v-for="item in prem.years"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="select">
            <p>薪资要求</p>
            <el-select v-model="body.wish_salary" placeholder="请选择">
              <el-option
                v-for="item in xz"
                :key="item.name"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
            <!-- <div class="select-input">ei n
                            <input v-model="body.wish_salary[0]" />
                            <span> ~ </span>
                            <input v-model="body.wish_salary[1]" />
                        </div>
                        <span class="select-unit">万/年</span>
                        <span class="select-prompt" v-if="salaryShow">*您的输入不正确，请重新输入</span> -->
          </div>
          <div class="select">
            <p>所在城市</p>
            <el-cascader
              v-model="props.city"
              :options="prem.citys"
              :props="{
                expandTrigger: 'hover',
                value: 'code',
                label: 'name',
                children: 'cities'
              }"
              @change="cityChange"
            ></el-cascader>
          </div>
          <div class="select">
            <p>职位名称</p>
            <el-cascader
              v-model="props.positions"
              :options="prem.positions"
              :props="{ expandTrigger: 'hover', value: 'id', label: 'name' }"
              @change="posChange"
            ></el-cascader>
          </div>
        </div>
        <section class="filter-top-right">
          <el-button
            type="primary"
            style="width: 90px;padding: 10px;"
            v-on:click="query"
            >查询</el-button
          >
          <el-button style="width: 60px;padding: 10px;" v-on:click="reset"
            >重置</el-button
          >
        </section>
      </div>
      <div class="search-list">
        <searchList :par="par" ref="child"></searchList>
        <!-- <div v-if="isShow" class="img-box">
                    <img src="@/assets/imgs/personnelsearch.png" />
                </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import $Apiresume from "@/api/ResumeModule";
import $Apipublic from "@/api/PublicModule";
import searchList from "./personnelsearchresult";
// import { provinces } from "https://static.ijiwei.com/city.json"
// const provinces = require("https://static.ijiwei.com/city.json");
export default {
  components: { searchList },
  data() {
    return {
      //公共参数
      prem: {},
      //提示
      salaryShow: false,
      //向下一页传值body
      body: this.initbody(),
      par: {},
      isShow: true,
      props: {
        //String => Array
        job: "",
        years: "",
        positions: [],
        city: []
      },
      xz: [
        { name: "年薪不限", val: [] },
        { name: "6万以下", val: ["0", "6"] },
        { name: "6-12万", val: ["6", "12"] },
        { name: "12-24万", val: ["12", "24"] },
        { name: "24-60万", val: ["24", "60"] },
        { name: "60万以上", val: ["60", "9999"] }
      ]
    };
  },
  created() {
    this.getData();
  },
  //激活keep-alive触发
  activated() {},
  destroyed() {},
  methods: {
    //获取公共数据
    getData() {
      $Apipublic
        .getPublicFormList()
        .then(data => {
          this.prem = { ...this.prem, ...data.data.data };
        })
        .catch(err => {
          // console.log("err"+err);
        });
      $Apipublic.getCity().then(data => {
        this.prem = { ...this.prem, citys: data.data.provinces };
      });
    },
    //职能分类多级查询
    posChange(e) {
      this.body.wish_positions = [this.changeArray(e)];
    },
    //省市分类多级查询
    cityChange(e) {
      this.body.wish_map_code = this.changeArray(e)[
        this.changeArray(e).length - 1
      ];
    },
    //去除0
    changeArray(arr) {
      if (arr) {
        return arr[0] == "0" ? [] : arr;
      }
      return arr;
    },
    //数组过滤 ""
    filters(arr) {
      return arr.filter(item => !(!item || item === ""));
    },
    //body初始化
    initbody() {
      return {
        page: 1,
        limit: 10,
        sort_type: "",
        job_status: "",
        project_word: "",
        educ_list: [],
        years: [],
        wish_positions: [],
        wish_map_code: "",
        wish_salary: []
      };
    },
    //---------------------------------------------------------------------------------------
    //搜索
    search() {
      this.query();
    },
    //查询
    query() {
      let body = this.body; //浅拷贝----如果退回页面就会发生数据错误
      if (this.numCheck()) {
        //临时处理...
        body.years = this.changeArray(this.filters([this.props.years]));
        body.job_status = this.changeArray(this.filters([this.props.job]));
        body.page = 1;
        this.gotolink(body);
      }
    },
    //重置
    reset() {
      this.body = this.initbody();
      this.props = { job: "", years: "", educ: "", positions: [], city: [] };
      // this.$refs.child.empty();
      // this.isShow = true;
      this.gotolink(this.body);
    },
    //路由
    gotolink(body) {
      this.isShow = false;
      this.par = body;
      this.$refs.child.getData(body);
      // this.$router.push({
      //     name: "PersonnelResult",
      //     query: {
      //         body: JSON.stringify(body)
      //     }
      // });
    },
    //check
    numCheck() {
      let arr = this.filters(this.body.wish_salary || []);
      switch (arr.length) {
        case 0:
          this.salaryShow = false;
          return true;
          break;
        case 1:
          this.salaryShow = true;
          return false;
          break;
        case 2:
          const min = parseInt(arr[0]);
          const max = parseInt(arr[1]);
          if (min <= max) {
            this.salaryShow = false;
            return true;
          } else {
            this.salaryShow = true;
            return false;
          }
          break;
        default:
          throw new Error("期望薪资检查异常");
          return false;
      }
    }
  }
};
</script>
<style scoped>
/* input */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

input[type="number"] {
  -moz-appearance: textfield !important;
}
.search-list {
  position: relative;
  margin-top: 17px;
  border-radius: 5px;
}
.search-list .img-box {
  width: 100%;
  position: absolute;
  background-color: #fff;
  text-align: center;
  z-index: 999;
  top: 0;
}
#app {
}

/* 搜索 */
.seach {
  position: absolute;
  top: 84px;
  width: 1080px;
  height: 78px;
  background: #fff;
  display: flex;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

/* 筛选 */
.filter {
  width: 1080px;
  /* margin-top: 88px; */
  display: flex;
  /* background: #fff; */
  border-radius: 5px;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;
  padding: 0 0 32px 0;
  box-sizing: border-box;
}

.filter .filter-top {
  display: flex;
  width: 100%;
  height: 157px;
  justify-content: space-between;
  align-items: flex-start;

  height: 131px;
  position: relative;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 5px;
}

.filter .filter-top .filter-top-left {
  display: flex;
  /* width: 869px; */
  height: 100%;
  padding-left: 10px;
  flex-flow: wrap;
  align-items: flex-end;
  justify-content: flex-start;
}

.filter .filter-top .filter-top-left .select {
  position: relative;
  display: flex;
  /* width: 250px; */
  /* height: 58px; */
  justify-content: flex-end;
  align-items: center;

  margin-left: 20px;
}

.filter .filter-top .filter-top-left .select:last-of-type {
  /* width: 295px; */
}

.filter .filter-top .filter-top-left .select .el-select,
.el-cascader {
  width: 178px;
  /* height: 34px; */
}

.filter .filter-top .filter-top-left .select p {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #666666;
  margin-right: 6px;
}

.filter .filter-top .filter-top-left .select .select-input {
  display: flex;
  width: 120px;
  justify-content: space-between;
  align-items: center;
}

.filter .filter-top .filter-top-left .select .select-input span {
  font-size: 25px;
  color: #999;
}

.filter .filter-top .filter-top-left .select .select-input input {
  width: 47px;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(231, 231, 231, 1);
  padding: 0 8px;
  box-sizing: border-box;
  text-align: center;
}

.filter .filter-top .filter-top-left .select .select-input input:focus {
  outline: none;
  border: 1px solid #669ace;
}

.filter .filter-top .filter-top-left .select .select-unit {
  font-size: 14px;
  color: #666;
  margin-left: 10px;
}

.filter .filter-top .filter-top-left .select .select-prompt {
  position: absolute;
  bottom: -15px;
  right: 0;
  font-size: 12px;
  color: #ff1935;
}

.filter .filter-top .filter-top-right {
  display: flex;
  /* width: 211px;
        height: 150px; */
  justify-content: flex-start;
  align-items: flex-end;
  position: absolute;
  right: 30px;
  bottom: 20px;
}

.filter img {
  width: 534px;
  height: 348px;
  margin-top: 74px;
}
</style>



// WEBPACK FOOTER //
// src/views/resume/personnelsearch.vue